import { factory } from '@repo-level/core-front';

export const confirmUserLimitDisable = factory((r) => (token: any) =>
  r<any>('post', 'user_limits/confirm', { token })
);

export const updatePlayerTerms = factory(
  (r) => (data: { terms_acceptance: boolean }) =>
    r<null>('post', `auth_providers/update_details`, {
      user: {
        terms_acceptance: data.terms_acceptance,
      },
    })
);
